import { t } from 'i18next'
import React from 'react'

export const DocumentAddressDetails = ({ details }) => {
  const addressDetail = details?.DeliverySetting?.ShippingAddress
  const warehouseDetail = details?.Warehouse

  return (
    <div className="documents-detail-info-gen-retiro">
      {addressDetail?.DetailedAddress && (
        <>
          <p className="documents-detail-info-gen-text">
            {t('DETAIL_DOCUMENTS_T.DELIVERY_HOME')}
          </p>
          <p className="documents-detail-info-gen-text">
            {t('DETAIL_DOCUMENTS_T.ADDRESS_LABEL', {
              address:
                addressDetail?.DetailedAddress ||
                t('DETAIL_DOCUMENTS_T.NO_INFO_LABEL'),
            })}
          </p>
          {addressDetail?.AddressFiscalCode && (
            <p className="documents-detail-info-gen-text">
              {`${addressDetail?.AddressFiscalCode?.CountryName}, ${addressDetail?.AddressFiscalCode?.ProvinceName}, ${addressDetail?.AddressFiscalCode?.DistrictName}, ${addressDetail?.AddressFiscalCode?.TownshipName}`}
            </p>
          )}
        </>
      )}
      {!addressDetail?.DetailedAddress && (
        <>
          <p className="documents-detail-info-gen-text">
            {t('DETAIL_DOCUMENTS_T.BRANCH_RECOLECTION_LABEL')}
          </p>
          <p className="documents-detail-info-gen-text">
            {warehouseDetail?.WarehouseName}
          </p>
          {warehouseDetail?.AddressFiscalCode && (
            <p className="documents-detail-info-gen-text">
              {t('DETAIL_DOCUMENTS_T.ADDRESS_LABEL', {
                address:
                  `${warehouseDetail?.AddressFiscalCode?.CountryName}, ${warehouseDetail?.AddressFiscalCode?.ProvinceName}, ${warehouseDetail?.AddressFiscalCode?.DistrictName}, ${warehouseDetail?.AddressFiscalCode?.TownshipName}` ||
                  t('DETAIL_DOCUMENTS_T.NO_INFO_LABEL'),
              })}
            </p>
          )}
        </>
      )}
    </div>
  )
}
